/*
 *
 * Email-confirmation constants
 *
 * In-app sign-up is retired (index.js forwards to the marketing product page),
 * so the SIGN_UP_* and RESEND_VERIFICATION_* action types that belonged to it
 * are gone — nothing dispatched them once the form was removed. Note the
 * removed RESEND_VERIFICATION_* types were NOT the ones SignInPage uses: those
 * are its own, under a different `src/SignInPage/…` prefix, and are untouched.
 *
 * What remains is the email-confirmation flow, which lives in this slice for
 * historical reasons: ConfirmEmailPage dispatches ACCOUNT_VERIFICATION_REQUEST
 * and reads the result back through this directory's reducer + selectors.
 *
 */

export const ACCOUNT_VERIFICATION_REQUEST = "src/ConfirmEmailPage/ACCOUNT_VERIFICATION_REQUEST";
export const ACCOUNT_VERIFICATION_SUCCESS = "src/ConfirmEmailPage/ACCOUNT_VERIFICATION_SUCCESS";
export const ACCOUNT_VERIFICATION_FAILURE = "src/ConfirmEmailPage/ACCOUNT_VERIFICATION_FAILURE";
